var map = {
	"./0.png": "b183",
	"./1.png": "134e",
	"./2.png": "b600",
	"./3.png": "db97",
	"./4.png": "2f7e",
	"./5.png": "2316",
	"./6.png": "b944",
	"./cap.png": "6de5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "48e3";